import { API, authClient } from "../index";
import { uploadSingleFile } from "../files";

// Get all web projects
export const getAllWebProjects = () => {
    return authClient().get(`${API}/webProject/?getDisabled=true`);
};

// Get webProject by id
export const getWebProjectById = (id) => {
    return authClient().get(`${API}/webProject/${id}`);
};

// Delete webProject
export const deleteWebProject = (id) => {
    return authClient().delete(`${API}/webProject/${id}`);
};

export const swapOrdersWebProject = async (id1, id2) => {
    return authClient().post(`${API}/webProject/swap-orders`, { id1, id2 });
};

// Create webProject
export const postWebProject = async (webProject, logo) => {

    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        webProject.logoURL = response?.data?.fileURL;
    }

    return authClient().post(`${API}/webProject`, webProject);
};

// Update webProject
export const updateWebProject = async (id, webProject, logo) => {

    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        webProject.logoURL = response?.data?.fileURL;
    }
    return authClient().put(`${API}/webProject/${id}`, webProject);
};

// Change status project
export const changeStatusWebProjectStatus = async (id, active) => {
    return authClient().put(`${API}/webProject/change-status/${id}`, { active });
};